import { render, staticRenderFns } from "./Obustave.vue?vue&type=template&id=24bf58bf&scoped=true&"
import script from "./Obustave.vue?vue&type=script&lang=js&"
export * from "./Obustave.vue?vue&type=script&lang=js&"
import style0 from "./Obustave.vue?vue&type=style&index=0&id=24bf58bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf58bf",
  null
  
)

export default component.exports